import { middlewareController } from '../middlewareController'

const BASE_URL = process.env.REACT_APP_AFTER_SALES_SERVICE_URL

export const afterSalesApi = middlewareController.create.axiosInstance({
  baseURL: BASE_URL
})

export * from './requests'
